var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "growth-svgrepo-com 1",
    clipPath: "url(#clip0_9858_29175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.8367 73.4694V16.3266C71.8367 15.425 71.1058 14.6939 70.2041 14.6939H58.7755C57.8738 14.6939 57.1429 15.425 57.1429 16.3266V73.4694H55.5102V31.0204C55.5102 30.1189 54.7793 29.3878 53.8775 29.3878H42.449C41.5473 29.3878 40.8163 30.1189 40.8163 31.0204V73.4694H39.1837V40.8164C39.1837 39.9148 38.4527 39.1837 37.551 39.1837H26.1224C25.2207 39.1837 24.4898 39.9148 24.4898 40.8164V73.4694H22.8571V52.2449C22.8571 51.3434 22.1262 50.6123 21.2245 50.6123H9.79592C8.8942 50.6123 8.16327 51.3434 8.16327 52.2449V73.4694H0V76.7347H80V73.4694H71.8367ZM19.5918 73.4694H11.4286V61.2245H19.5918V73.4694ZM19.5918 57.9592H11.4286V53.8776H19.5918V57.9592ZM35.9184 73.4694H27.7551V49.796H35.9184V73.4694ZM35.9184 46.5306H27.7551V42.449H35.9184V46.5306ZM52.2449 73.4694H44.0816V40H52.2449V73.4694ZM52.2449 36.7347H44.0816V32.6531H52.2449V36.7347ZM68.5714 73.4694H60.4082V25.3062H68.5714V73.4694ZM68.5714 22.0408H60.4082V17.9592H68.5714V22.0408Z",
    fill: "url(#paint0_linear_9858_29175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.31883 46.0526L46.5316 8.83969V14.6939H49.7969V4.89797C49.7969 3.99642 49.0659 3.26532 48.1642 3.26532H37.552V6.53063H44.2225L7.00977 43.7435L9.31883 46.0526Z",
    fill: "url(#paint1_linear_9858_29175)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9858_29175",
    x1: 17.1429,
    y1: 91.1371,
    x2: 79.2373,
    y2: 30.3438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9858_29175",
    x1: 16.1784,
    y1: 55.9853,
    x2: 57.4375,
    y2: 24.6591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B733"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4A1A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9858_29175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenKpi);
export default __webpack_public_path__ + "static/media/openKPI.3ea52753e685f98c576485c93691c79e.svg";
export { ForwardRef as ReactComponent };